import commonEnvironment from 'config/de-CH/common-environment';
import paypal from 'config/paypal';
import { ShopEnvironment } from 'config/types';

export default {
  ...commonEnvironment,
  apiEndpoint: 'https://dev.petsdeli.ch:3001',
  backInStockUrl: 'https://pets-deli-staging-ch.myshopify.com',
  contentfulEnv: 'staging',
  foodaidEndpoint: 'https://api.petsdeli.de/fube-staging-2023-04',
  ninetailedEnv: 'development',
  oosEndpoint: 'https://api-staging.oos.petsdeli.ch',
  paypalClientId: paypal.staging,
  pdexEndpoint: 'https://dev.petsdeli.ch:4001',
  shopifyUrl: 'https://pets-deli-staging-ch.myshopify.com',
  gtmScriptUrl:
    'https://metrics.petsdeli.ch/gtm.js?id=GTM-NK69QT6&gtm_auth=mVziPUTr8RQqgHd0gjcs7Q&gtm_preview=env-334&gtm_cookies_win=x',
  gtmNoScriptUrl:
    'https://metrics.petsdeli.ch/gtm.html?id=GTM-NK69QT6&gtm_auth=mVziPUTr8RQqgHd0gjcs7Q&gtm_preview=env-334&gtm_cookies_win=x',
} satisfies ShopEnvironment;
